import { Component } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import Document from '@/views/Project/HSE/components/document/document.vue'

@Component({
    mixins: [ProjectMixin],
    components: { Document },
})
export default class Documents extends Mixins<MixinInterface>(ProjectMixin) {
    includeArchived = false

    get isPublic() {
        return this.$route.fullPath.includes('public') ? true : false
    }

    get isDocuments() {
        return this.$route.fullPath.includes('documents')
    }

    // get projectId(){
    //     return this.$route.params.type == 'p' ? this.$route.params.id : this.$route.query.projectId
    // }

    // get project(){
    //     return this.projectId ? this.$store.getters.project(this.projectId) : null
    // }

    get HSEDocuments() {
        const documentFilter = (item: any, filterFn: (attributes: any) => boolean) => {
            const document = this.$store.getters.hseDocument(item.id)
            return filterFn(document.attributes)
        }

        return this.currentProject
            ? this.isPublic
                ? this.currentProject.relationships.hseDocuments.data.filter((item: any) => {
                      return documentFilter(
                          item,
                          (attributes: any) =>
                              attributes.isPublic &&
                              (!attributes.isArchived || this.includeArchived)
                      )
                  })
                : this.currentProject.relationships.hseDocuments.data.filter((item: any) => {
                      return documentFilter(
                          item,
                          (attributes: any) => !attributes.isArchived || this.includeArchived
                      )
                  })
            : null
    }
}
